// Skia is not initialized on web — return null so callers fall back to RN Text.
export const useSkiaFont = (..._args: unknown[]): null => null;
